import { $RootStore } from '../../../../src/stores/RootStore'
import { SetupTaskId } from '../setupTasksData'
import { SetupStep } from './d'

export const GettingStartedStepIds = {
  locations: `${SetupTaskId.GettingStarted}-locations`,
  inviteTeam: `${SetupTaskId.GettingStarted}-inviteTeam`,
  treatments: `${SetupTaskId.GettingStarted}-treatments`,
  website: `${SetupTaskId.GettingStarted}-website`,
  addBooking: `${SetupTaskId.GettingStarted}-addBooking`,
} as const

const bookingSystemSetupSteps: SetupStep[] = [
  {
    title: 'Add your business location',
    taskId: SetupTaskId.GettingStarted,
    id: GettingStartedStepIds.locations,
    icon: 'mapLocation',
    description: 'Set your location, working hours and where clients can book you.',
    check: (_rootStore: $RootStore) => {
      return false // Platform-specific check defined in stepData.ts
    },
    __reset: async (rootStore: $RootStore) => {
      const { data: { professionalProfile }, fetch_api } = rootStore.userStore
      await fetch_api()

      await rootStore.userStore.updateSaasSettings_api({
        mobileLocation: {
          ...professionalProfile.saasSettings.mobileLocation!,
          enabled: false,
        },
        staticLocations: [],
      })
    },
    toastData: {
      title: 'You\'ve set up your location!',
      nextStepId: SetupTaskId.GettingStarted,
    },
    startAction: async (_rootStore: $RootStore) => {
      // Platform-specific action defined in stepData.ts
    },
    dependsOnStepIds: [],
  },
  {
    title: 'Invite your team members',
    taskId: SetupTaskId.GettingStarted,
    id: GettingStartedStepIds.inviteTeam,
    icon: 'team',
    description: 'Invite the people who work with you so clients can book them.',
    canSkip: true,
    hidden: (rootStore: $RootStore) => !rootStore.authStore.isSalonSession,
    check: (rootStore: $RootStore) => rootStore.salonStore.hasInvitedTeam,
    toastData: {
      title: 'You\'ve invited your team!',
      nextStepId: SetupTaskId.GettingStarted,
    },
    startAction: async () => {},
    dependsOnStepIds: [],
  },
  {
    title: 'Create your service menu',
    taskId: SetupTaskId.GettingStarted,
    id: GettingStartedStepIds.treatments,
    icon: 'treatments',
    description: 'Add your treatments so clients can book and pay for services.',
    check: (rootStore: $RootStore) => {
      return rootStore.externalTreatmentStore.items.length > 0
    },
    __reset: async (rootStore: $RootStore) => {
      await rootStore.communication.requester.deleteSaasData({ models: ['ExternalTreatment'] })
      rootStore.externalTreatmentStore.items = []
    },
    toastData: {
      title: 'You added your first treatment!',
      nextStepId: SetupTaskId.GettingStarted,
    },
    startAction: async (_rootStore: $RootStore) => {
      // Platform-specific action defined in stepData.ts
    },
    dependsOnStepIds: [],
  },
  {
    title: 'Set up your website',
    taskId: SetupTaskId.GettingStarted,
    id: GettingStartedStepIds.website,
    icon: 'globe',
    description: 'Start setting up your website to start receiving bookings.',
    check: (_rootStore: $RootStore) => {
      // Platform-specific check defined in stepData.ts
      return false
    },
    __reset: async (rootStore: $RootStore) => {
      rootStore.userStore.data.professionalProfile.saasSettings.isPublic = false
    },
    toastData: {
      title: 'You\'ve set up your website!',
      nextStepId: SetupTaskId.GettingStarted,
    },
    startAction: async (_rootStore: $RootStore) => {
      // Platform-specific action defined in stepData.ts
    },
    dependsOnStepIds: [],
  },
]

export default bookingSystemSetupSteps
